import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { Check, ShieldCheck, Gift } from 'lucide-react';
export function Purchase() {
  const includes = ['Acceso inmediato al material completo', '4 Tomos + 6 Bonos en formato PDF', 'Plantillas 100% editables', 'Soporte por email'];
  return <section id="comprar" className="w-full bg-gradient-to-b from-teal-700 to-teal-900 py-20 px-4" data-id="element-125">
      <div className="max-w-2xl mx-auto" data-id="element-126">
        <div className="mb-8" data-id="element-127">
          <CountdownTimer data-id="element-128" />
        </div>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-129">
          {/* Header */}
          <div className="bg-teal-600 text-white text-center py-5 px-6" data-id="element-130">
            <p className="text-sm uppercase tracking-widest text-teal-100 mb-1" data-id="element-131">
              Oferta por tiempo limitado
            </p>
            <h2 className="text-2xl md:text-3xl font-extrabold" data-id="element-132">
              Megapack Acompañante Pedagógico
            </h2>
          </div>

          <div className="p-8" data-id="element-133">
            {/* Gift banner */}
            <div className="flex items-center justify-center gap-2 bg-yellow-100 text-yellow-800 rounded-full py-2 px-4 mb-6 text-sm font-semibold mx-auto w-fit" data-id="element-134">
              <Gift className="w-4 h-4" data-id="element-135" />
              <span data-id="element-136">6 bonos GRATIS solo por hoy</span>
            </div>

            {/* Price */}
            <div className="text-center mb-8" data-id="element-137">
              <p className="text-base text-gray-400 line-through" data-id="element-138">
                Antes $55.900
              </p>
              <div className="flex items-end justify-center gap-1 mt-1" data-id="element-139">
                <span className="text-2xl font-bold text-teal-600 mb-2" data-id="element-140">$</span>
                <span className="text-6xl md:text-7xl font-extrabold text-teal-600 leading-none" data-id="element-141">
                  19.990
                </span>
              </div>
              <span className="inline-block mt-3 bg-red-100 text-red-700 text-sm font-bold px-3 py-1 rounded-full" data-id="element-142">
                Ahorrás $35.910
              </span>
            </div>

            {/* Includes */}
            <ul className="space-y-3 mb-8" data-id="element-143">
              {includes.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-144">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-teal-100 flex items-center justify-center" data-id="element-145">
                    <Check className="w-4 h-4 text-teal-600" data-id="element-146" />
                  </span>
                  <span className="text-gray-700 font-medium" data-id="element-147">{item}</span>
                </li>)}
            </ul>

            {/* CTA */}
            <a href="https://checkout.ebookpoint.shop/cart/59617061929041:1" className="block w-full bg-teal-600 hover:bg-teal-700 text-white font-extrabold py-5 px-8 rounded-xl text-xl text-center shadow-lg hover:shadow-2xl hover:-translate-y-0.5 transition-all" data-id="element-148">
              Empezá a ahorrar horas
            </a>

            <div className="flex flex-col items-center justify-center gap-1 mt-5 text-sm text-gray-500" data-id="element-149">
              <div className="flex items-center gap-2" data-id="element-150">
                <ShieldCheck className="w-4 h-4 text-teal-600" data-id="element-151" />
                <span data-id="element-152">Pago seguro • Acceso inmediato</span>
              </div>
              <span className="font-semibold text-[#009ee3]" data-id="element-153">MercadoPago</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}